import React from "react";
import { EmptyPro } from "../../assets/images";
import { Like } from "..";
import { AiOutlineClose } from "react-icons/ai";
import { FeedLikeType, UserFeedsType } from "../../types";
import { GET_FEED_LIKES } from "../../apollo/operations";
import { useQuery } from "@apollo/client";

type ProfileLikeNavProps = {
  userFeeds: UserFeedsType | undefined;
};

const ProfileLikeNav: React.FC<ProfileLikeNavProps> = ({ userFeeds }) => {
  const [noLike, setLike] = React.useState<any>();
  const [openCollection, setOpenCollection] = React.useState(false);
  const [collectionName, setCollectionName] = React.useState("");
  const [isOnChange, setIsOnChange] = React.useState(false);

  const [feedLikes, setFeedLikes] = React.useState<FeedLikeType | undefined>(
    {} as any
  );

  const userID = window.localStorage.getItem("user");

  const { refetch: refetchLikes, loading: loadLikes } = useQuery(
    GET_FEED_LIKES,
    {
      variables: {
        where: {
          likedBy: {
            id: userID,
          },
        },
      },
      notifyOnNetworkStatusChange: true,
      onCompleted: (data) => {
        // console.log(data);
        setFeedLikes(data);
      },
    }
  );

  // console.log(feedLikes);

  if (openCollection) {
    document.body.classList.add("overflow-y-hidden");
  } else {
    document.body.classList.remove("overflow-y-hidden");
  }

  const handleOnChange = (e: any) => {
    const inputValue = e.target.value;
    if (inputValue.trim().length > 0) {
      setIsOnChange(true);
    } else {
      setIsOnChange(false);
    }
    setCollectionName(inputValue);
  };

  return (
    <div className="w-full">
      {!feedLikes ? (
        <div className="grid grid-cols-3 mt-14 pb-3">
          <div className="col-start-2 flex flex-col">
            <div className="w-[20%">
              <img src={EmptyPro} alt="" />
            </div>
            <div className="ml-4 font-Inter text-[15px] text-[#B9B4B4] text-center mt-1">
              No Liked Pictures or Videos
              {/* Start by <span className=' text-midGreen cursor-pointer text-center' onClick={() => setOpenCollection(true)}>creating a collection</span> */}
            </div>
          </div>
        </div>
      ) : (
        <div>{feedLikes && <Like like={feedLikes} />}</div>
      )}
      {openCollection && (
        <div className="fixed inset-0 flex justify-center bg-[#000000CC] items-center">
          <div className="bg-white flex flex-col justify-between shadow rounded w-[428px] h-[205px]">
            <div className="grid grid-cols-4 px-3 border-b border-solid w-full text-center py-4 text-[#000] font-Poppins text-base font-medium items-center justify-between">
              <div className=" col-start-2 col-span-2">New Collection</div>
              <div className="col-start-4 justify-items-end grid">
                <AiOutlineClose
                  onClick={() => setOpenCollection(false)}
                  className="cursor-pointer"
                />
              </div>
            </div>
            <div className="flex px-3">
              <input
                type="text"
                className="block h-12 rounded outline-none w-full pl-3 justify-center text-[#B9B4B4] bg-[#F6F7F9] font-SegoeUI text-sm"
                placeholder="Collection Name"
                value={collectionName}
                onChange={handleOnChange}
              />
            </div>
            <div
              className={`text-center border-t border-solid py-4 text-lightGreyText text-base font-Poppins w-full ${
                isOnChange ? "text-midGreen font-medium" : ""
              }`}
            >
              Next
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileLikeNav;
